import { SwRedux } from "app/services/SwRedux";
import type { IWidget } from "../widget-types/types";
import { DefaultDataFetcher } from "./DefaultDataFetcher";
import type { IDataFetcherFactory } from "./IDataFetcher";

export class ReduxStateAwareDataFetcher<T> extends DefaultDataFetcher<T> {
    protected statePath: string;
    protected reduxService: SwRedux;
    private unSubscribe: () => void;

    constructor(widget, statePath) {
        super(widget);
        this.statePath = statePath;
        this.reduxService = SwRedux.getInstance();
        this.unSubscribe = this.reduxService.notifyOnChange(this.statePath, this.callback.bind(this));
    }

    callback() {
        this.widget.runWidget();
    }

    destroy(): void {
        this.unSubscribe();
    }
}

const ReduxStateAwareDataFetcherFactory: IDataFetcherFactory<any> = {
    create: function (widget: IWidget, { statePath }) {
        return new ReduxStateAwareDataFetcher<any>(widget, statePath);
    },
};

export default ReduxStateAwareDataFetcherFactory;
